<template>
  <div id="select-hits-table" class="mt-3">
    <div class="row">
      <div class="col-8">
        <b-form-select class="shadow-sm d-inline flaot-left"
          v-model="selectedPoint" :options="pointList" />
      </div>
      <div class="col-4 text-center">
        <b-button variant="info" class="w-100"
          @click="$router.push('/pattern');">
          検索<font-awesome-icon icon="search" />
        </b-button>
      </div>
    </div>
    <div v-if="selectedPoint >= 0" class="mt-1">
      <HitsTable :hits="hitsList[selectedPoint]" :isHeader="false"
        :label="labels[selectedPoint]" :gameInfo="gameInfo" @edit="editHits" />
      <TableTennisTable :hits="hitsList[selectedPoint]"
        :label="labels[selectedPoint]" :gameInfo="gameInfo"/>
    </div>
  </div>
</template>

<script>
import HitsTable from '@/components/molecules/HitsTable';
import TableTennisTable from '@/components/molecules/TableTennisTable';
import func from '@/lib/func';
import CmnConst from '@/lib/cmnConst';

export default {
  name: 'select-hits-table',
  props: ['points', 'labels', 'gameInfo', 'selected', 'hitsList'],
  components: {
    HitsTable,
    TableTennisTable,
  },
  data() {
    return {
      selectedPoint: 0,
      CmnConst,
    };
  },
  computed: {
    pointList() {
      const options = [];
      let info = { p1: 0, p2: 0, s1: 0, s2: 0, nextSv: 0 };
      for (let i = 0; i < this.points.length; i++) {
        options.push({ value: i, text: `${info.s1 + info.s2 + Math.max(this.selected, 1)}ゲーム目 ${info.p1} - ${info.p2}` });
        info = func.nextPoint(info, this.points[i]);
      }
      return options;
    },
  },
  methods: {
    editHits(idx) {
      this.$emit('edit', this.selectedPoint, idx);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/molecules/SelectHitsTable.vue